import styled from 'styled-components';

import { Colour, Shadow } from '@xemplo/style-constants';

export const RadioButtonV2 = styled.input`
  --radio-btn-border-color: ${Colour.Gray[300]};
  --radio-btn-border-width: 2px;
  --radio-btn-bg-color: ${Colour.Dark[5]};
  --radio-btn-box-shadow-color: transparent;
  --radio-btn-size: 24px;

  appearance: none;
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;
  border-radius: 50%;
  transition: 0.1s box-shadow ease-out;
  cursor: pointer;
  width: var(--radio-btn-size);
  height: var(--radio-btn-size);
  border: var(--radio-btn-border-width) solid var(--radio-btn-border-color);
  box-shadow: 0 0 0 12px var(--radio-btn-box-shadow-color);

  &:hover:not(&.is-invalid) {
    --radio-btn-bg-color: ${Colour.Dark[5]};
    --radio-btn-box-shadow-color: ${Colour.Dark[5]};
    --radio-btn-border-color: ${Colour.Gray[400]};
    background: var(--radio-bg-color);

    &:checked {
      --radio-btn-box-shadow-color: rgb(0, 96, 215, 0.1);
      --radio-btn-border-color: ${Colour.Blue[600]};
    }
  }
  &:checked:not(&.hideSelected) {
    --radio-btn-border-color: ${Colour.Blue[500]};
    --radio-btn-border-width: 6px;
  }

  /** Small variant */
  &.size-small {
    --radio-btn-size: 16px;
    box-shadow: 0 0 0 8px var(--radio-btn-box-shadow-color);
    &:hover {
    }
    &:checked:not(&.hideSelected) {
      --radio-btn-border-width: 4px;
    }
  }
  /** Medium variant */
  &.size-medium {
    --radio-btn-size: 20px;
    box-shadow: 0 0 0 10px var(--radio-btn-box-shadow-color);
    &:checked:not(&.hideSelected) {
      --radio-btn-border-width: 5px;
    }
  }

  &:disabled {
    opacity: 0.2;
    pointer-events: none;
  }
  /** Invalid styling  */
  &.is-invalid,
  &:user-invalid {
    --radio-btn-border-color: ${Colour.Red[500]};
    &:not(:checked) {
      border: var(--radio-btn-border-width) solid var(--radio-btn-border-color);
      &::before {
        content: '';
        position: absolute;
        width: var(--radio-btn-size);
        height: var(--radio-btn-size);
        border-radius: 50%;
        box-shadow: ${Shadow.Error};
        top: -2px;
        left: -2px;
      }
      &.size-small {
        &::before {
          width: var(--radio-btn-size);
          height: var(--radio-btn-size);
        }
      }
      &.size-medium {
        &::before {
          width: var(--radio-btn-size);
          height: var(--radio-btn-size);
        }
      }
    }
  }

  &.success {
    --radio-btn-border-color: ${Colour.Green[500]};
    --radio-btn-border-width: 6px;
    &.size-small {
      --radio-btn-border-width: 4px;
    }

    &.size-medium {
      --radio-btn-size: 20px;
      --radio-btn-border-width: 5px;
    }
    pointer-events: none;
  }

  &.error {
    --radio-btn-border-color: ${Colour.Red[500]};
    --radio-btn-border-width: 6px;

    &.size-small {
      --radio-btn-border-width: 4px;
    }

    &.size-medium {
      --radio-btn-size: 20px;
      --radio-btn-border-width: 5px;
    }
    pointer-events: none;
  }
`;
